/**
 * Type Beauty — PDP / bundle / sample UI helpers (vanilla only).
 * Covers: toggle-tab "Show More", bundle shade pickers, sample color matching, Diwali selects.
 */
(function () {
  'use strict';

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  /* ---------- Collapsible "Show More" for toggle-tab ---------- */
  function initToggleTabs() {
    var tabs = Array.prototype.slice.call(document.querySelectorAll('toggle-tab'));
    if (tabs.length <= 6) return;
    if (document.getElementById('toggleButton')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'toggleButton';
    btn.textContent = 'Show More';
    tabs[5].after(btn);

    var extras = tabs.slice(6);
    extras.forEach(function (tab) {
      tab.hidden = true;
      tab.style.display = 'none';
    });

    btn.addEventListener('click', function () {
      var open = btn.textContent === 'Show More';
      extras.forEach(function (tab) {
        tab.hidden = !open;
        tab.style.display = open ? '' : 'none';
      });
      btn.textContent = open ? 'Show Less' : 'Show More';
    });
  }

  /* ---------- Bundle shade radio → selected text + selected-var ---------- */
  var SHADE_MAP = [
    {
      input: '.concealer-custom-shades .product-variant__input',
      scope: '.concealer-custom-shades',
      text: '.concealer-selected-shade span',
      label: '.product-variant__label'
    },
    {
      input: '.foundation-custom-shades .product-variant__input1',
      scope: '.foundation-custom-shades',
      text: '.foundation-selected-shade span',
      label: '.product-variant__label1'
    },
    {
      input: '.skin-tint-custom-shades .product-variant__input',
      scope: '.skin-tint-custom-shades',
      text: '.skin-tint-selected-shade span',
      label: '.product-variant__label'
    },
    {
      input: '.jelly-custom-shades .product-variant__input1',
      scope: '.jelly-custom-shades',
      text: '.jelly-selected-shade span',
      label: '.product-variant__label1'
    },
    {
      input: '.lip-oil-custom-shades .product-variant__input1',
      scope: '.lip-oil-custom-shades',
      text: '.lip-oil-selected-shade span',
      label: '.product-variant__label1'
    }
  ];

  function onBundleShadeClick(e) {
    var t = e.target;
    if (!t || !t.matches) return;

    for (var i = 0; i < SHADE_MAP.length; i++) {
      var cfg = SHADE_MAP[i];
      if (!t.matches(cfg.input)) continue;
      var root = closest(t, cfg.scope) || document;
      var span = root.querySelector(cfg.text) || document.querySelector(cfg.text);
      if (span) span.textContent = t.value;
      root.querySelectorAll(cfg.label).forEach(function (lab) {
        lab.classList.remove('selected-var');
      });
      var lab = t.nextElementSibling;
      while (lab && !lab.matches(cfg.label)) lab = lab.nextElementSibling;
      if (lab) lab.classList.add('selected-var');
      return;
    }
  }

  /* ---------- Sample shade match highlighting ---------- */
  function onSampleLabelClick(e) {
    var lab = closest(e.target, '.product-variant__label, .product-variant__label1, .product-variant__label3');
    if (!lab) return;
    if (!document.querySelector("input[name='product-color']")) return;

    var item = closest(lab, '.product-variant__item');
    if (item) {
      item.querySelectorAll('label').forEach(function (l) {
        l.classList.add('input-unmatched');
      });
    }

    var input = lab.previousElementSibling;
    while (input && input.tagName !== 'INPUT') input = input.previousElementSibling;
    var value = input ? input.value : '';

    document.querySelectorAll("input[name='product-color']").forEach(function (el) {
      var parent = closest(el, '.product-variant__item');
      if (!parent) return;
      var labels = parent.querySelectorAll('label');
      if (value === el.value) {
        labels.forEach(function (l) {
          l.classList.add('input-matched');
        });
      } else {
        labels.forEach(function (l) {
          l.classList.remove('input-matched', 'input-unmatched');
        });
      }
    });
  }

  /* ---------- Diwali big-select variant switching ---------- */
  function initDiwaliSelects() {
    document.querySelectorAll('.big-select').forEach(function (big) {
      var selectEl = big.querySelector('select');
      if (!selectEl) return;
      var variantDivs = big.querySelectorAll('.product__variants');
      var variantSelects = big.querySelectorAll('.side-selects');

      function showVariant() {
        var idx = selectEl.selectedIndex;
        variantDivs.forEach(function (el, i) {
          el.style.display = i === idx ? '' : 'none';
        });
        variantSelects.forEach(function (el, i) {
          el.style.display = i === idx ? '' : 'none';
        });
      }

      showVariant();
      selectEl.addEventListener('change', showVariant);
    });

    document.addEventListener('click', function (e) {
      var lab = closest(e.target, '.product-variant__label-diwali');
      if (!lab) return;
      var big = closest(lab, '.big-select');
      if (!big) return;
      big.querySelectorAll('.product-variant__label-diwali').forEach(function (el) {
        el.classList.remove('selected-var');
      });
      lab.classList.add('selected-var');
    });
  }

  function boot() {
    initToggleTabs();
    initDiwaliSelects();
    document.addEventListener('click', onBundleShadeClick);
    document.addEventListener('click', onSampleLabelClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
